import { markdownRegexes } from '.'

export default function sanitizeMarkdown(text) {
  return text
    .replace(markdownRegexes.regexBold, '$1')
    .replace(markdownRegexes.regexItalic, '$1')
    .replace(markdownRegexes.regexUnderline, '$1')
}
